import { template as template_11f8f765f8bb4b43be1cf4670871cf81 } from "@ember/template-compiler";
import SiteDocumentsSharedAutosaveMessage from 'client-portal/components/site/documents/shared/autosave-message';
import t from 'ember-intl/helpers/t';
export default template_11f8f765f8bb4b43be1cf4670871cf81(`
  <header class="intake-header">
    <h1>{{t "site.pages.waitlistIntake"}}</h1>
    <div class="title-rule" aria-hidden="true"></div>

    {{#unless @isComplete}}
      <div class="autosave" data-test-autosave-displayed={{@isAutosaveDisplayed}}>
        <SiteDocumentsSharedAutosaveMessage
          @tagName=""
          @isDisplayed={{@isAutosaveDisplayed}}
          @autosaveTask={{@autosaveTask}}
        />
      </div>
    {{/unless}}
  </header>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
